import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d2f141a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__rec-select" }
const _hoisted_2 = { class: "label-container" }
const _hoisted_3 = {
  class: "very-small",
  for: "wbb_select"
}
const _hoisted_4 = { class: "select-container" }
const _hoisted_5 = ["name"]
const _hoisted_6 = ["value"]

import { recProps } from 'vue/applications/frontend/mixins/rec-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-select',
  props: {...recProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.description.label), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("select", {
        id: "wbb_select",
        name: _ctx.description.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.description.ivalue) = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.options, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.value,
            key: option.value
          }, _toDisplayString(option.text), 9, _hoisted_6))
        }), 128))
      ], 8, _hoisted_5), [
        [_vModelSelect, _ctx.description.ivalue]
      ])
    ])
  ]))
}
}

})